// Need to use the React-specific entry point to import createApi
import config from "../config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Video } from "../../../api/src/types";
import { prepareHeaders } from "./utils";

export const videosApi = createApi({
  reducerPath: "videosApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.api,
    prepareHeaders,
  }),
  tagTypes: ["video"],
  endpoints: (builder) => ({
    getVideo: builder.query<
      Video,
      {
        questionId?: string | undefined;
        questionGroupId?: string | undefined;
        questionnaireSectionId?: string | undefined;
        location?: string | undefined;
        stateId?: string | undefined;
      }
    >({
      query: (videoData) => ({
        url: `videos`,
        params: videoData,
        method: "GET",
      }),
      providesTags: (result) =>
        result ? [{ type: "video", id: result.id }] : [{ type: "video" }],
    }),
  }),
});

export const { useGetVideoQuery } = videosApi;
